import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./style.css";

export default class Next extends Component {
  render() {
    return (
      <div className="next">
        <h1>Taimur Shah</h1>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Next/index.jsx